import {Component, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms';
import {NgbModal, NgbNav} from '@ng-bootstrap/ng-bootstrap';
import {DistrictService} from '../../services/district.service';
import {ActivatedRoute} from '@angular/router';
import {TitleService} from '../../services/title.service';
import {Level, ToastService} from '../../services/toast.service';
import {ConfirmModal} from '../../components/modals/confirm/confirm.modal';
import {RoleDto} from '@sidr/dto-types';
import {StudentBlock, StudentsModuleStaffTabConst, StudentsModuleStudentTabConst} from '../../constants/modules';

@Component({
  selector: 'app-role-list',
  templateUrl: './roleList.component.html',
})
export class RoleListComponent implements OnInit {
  roles: RoleDto[];
  active: any;
  districtId: string;

  sizing = 'col-sm-12 col-md-4 col-lg-3';

  studentTabs: StudentBlock[] = [];
  staffTabs: StudentBlock[] = [];

  constructor(
    private districtService: DistrictService,
    private activeRoute: ActivatedRoute,
    private titleService: TitleService,
    private toastService: ToastService,
    private modal: NgbModal) {
    this.roles = [];
    this.titleService.setTitle('Role Management');
    this.studentTabs = Array.isArray(StudentsModuleStudentTabConst)
      ? StudentsModuleStudentTabConst.map(x => x)
      : Object.values(StudentsModuleStudentTabConst as Record<string, StudentBlock>).map(x => x);
    this.staffTabs = Array.isArray(StudentsModuleStaffTabConst)
      ? StudentsModuleStaffTabConst.map(x => x)
      : Object.values(StudentsModuleStaffTabConst as Record<string, StudentBlock>).map(x => x);
  }

  getData() {
    this.districtService.getRoles(this.districtId).subscribe(roles => {
      this.roles = roles || [];
    });
  }

  ngOnInit(): void {
    this.activeRoute.parent?.parent?.params.subscribe(p => {
      if (p['districtId']) {
        this.districtId = p['districtId'];
        this.getData();
      }
    });
  }

  submit(roleForm: NgForm, role: RoleDto) {
    if (role.id && role.id.length > 0 && role.id !== 'new') {
      this.districtService.patchRole(this.districtId, role).subscribe(() => {
        this.toastService.AddNotification(Level.SUCCESS, 'Role Saved', 'Role has been saved');
        this.getData();
      }, err => {
        this.toastService.AddNotification(Level.ERROR, 'Role Error', 'Failed to save role');
      });
    } else {
      if (role.id === 'new') {
        delete role.id;
      }
      this.districtService.postRole(this.districtId, role).subscribe(() => {
        this.toastService.AddNotification(Level.SUCCESS, 'Role Added', 'Role has been added');
        this.getData();
      }, err => {
        this.toastService.AddNotification(Level.ERROR, 'Building Error', 'Failed to add building');
      });
    }
  }

  isAnyCheckedModule(role: RoleDto, module: string): boolean {
    return role.enabled_modules?.filter(value => value.indexOf(module) > -1).length > 0
  }

  isCheckedModule(role: RoleDto, module: string): boolean {
    return role.enabled_modules?.indexOf(module) > -1;
  }

  toggleEnabledModule(roleForm: NgForm, role: RoleDto, module: string) {
    if (!role.enabled_modules) {
      role.enabled_modules = [];
    }
    const index = role.enabled_modules.indexOf(module);
    if (index > -1) {
      role.enabled_modules.splice(index, 1);
    } else {
      role.enabled_modules.push(module);
    }
    roleForm.form.markAsTouched();
  }

  delete(role: RoleDto) {
    const ref = this.modal.open(ConfirmModal, {
      backdrop: 'static',
      centered: true,
    });
    ref.componentInstance.message = 'You are about to delete a role. This will potentially cause issues on staff, are you sure?';
    ref.result.then(resp => {
      if (resp) {
        this.districtService.deleteRole(this.districtId, role).subscribe(() => {
          this.modal.dismissAll();
          this.getData();
        });

      }
    }, x => {
    });
  }

  cancel(Form: NgForm) {

  }

  newRole(id: string, name: string): RoleDto {
    return {
      id: id,
      name: name,
      can_impersonate: false,
      can_admin: false,
      delete_roles: false,
      modify_roles: false,
      create_roles: false,
      delete_building: false,
      modify_district: false,
      delete_student: false,
      create_student: false,
      modify_staff: false,
      create_building: false,
      modify_building: false,
      modify_student: false,
      roam_buildings: false,
      roam_students: false,
      enabled_modules: [],
      created_staff: false,
      delete_staff: false,
    } as RoleDto;
}

  addrole(nav: NgbNav) {
    const role = this.newRole('new', "New Role");
    this.roles.push(role);
    this.active = 'new';
  }
}
